module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_52-a1fc1220925fcf43938f088a1e9e6fef.png";